{
  "accessibility.json": {
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "bindings.json": {
    "BindingsList": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextBindingConfig"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "connections_data.json": {
    "ConnectionList": [
      {
        "jsonPointer": "/items/controllerId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "AppController",
          "TPAWidget",
          "TPA",
          "TPAMultiSection"
        ],
        "path": [
          "items",
          "controllerId"
        ],
        "isRelationalSplit": false
      }
    ],
    "ConnectionItem": [
      {
        "jsonPointer": "/controllerId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "AppController",
          "TPAWidget",
          "TPA",
          "TPAMultiSection"
        ],
        "path": [
          "controllerId"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "contexts.json": {
    "ContextsList": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextConfig"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContextConfig": [
      {
        "jsonPointer": "/data",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "data"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "controllers.json": {
    "ControllerList": [
      {
        "jsonPointer": "/controllers",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "AppController",
          "TPAWidget",
          "TPA",
          "TPAMultiSection"
        ],
        "path": [
          "controllers"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "cursor.json": {
    "Cursor": [
      {
        "jsonPointer": "/media",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image",
          "SVGItem"
        ],
        "path": [
          "media"
        ],
        "isRelationalSplit": false
      }
    ],
    "Image": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/originalImageDataRef",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "originalImageDataRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "document_data.json": {
    "SVGReference": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BackgroundMedia": [
      {
        "jsonPointer": "/mediaRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image",
          "WixVideo"
        ],
        "path": [
          "mediaRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/imageOverlay",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "imageOverlay"
        ],
        "isRelationalSplit": false
      }
    ],
    "WixVideo": [
      {
        "jsonPointer": "/posterImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "posterImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "WixVideoData": [
      {
        "jsonPointer": "/posterImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "posterImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "Document": [
      {
        "jsonPointer": "/mainPage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "mainPage"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/smSettings/termsOfUse/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "smSettings",
          "termsOfUse",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/smSettings/privacyPolicy/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "smSettings",
          "privacyPolicy",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/smSettings/codeOfConduct/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "smSettings",
          "codeOfConduct",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/appStudioData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "AppStudioData"
        ],
        "path": [
          "appStudioData"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/appsInstallState",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "AppsInstallState"
        ],
        "path": [
          "appsInstallState"
        ],
        "isRelationalSplit": false
      }
    ],
    "SiteMembersData": [
      {
        "jsonPointer": "/termsOfUse/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "termsOfUse",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/privacyPolicy/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "privacyPolicy",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/codeOfConduct/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "codeOfConduct",
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "AppStudioData": [
      {
        "jsonPointer": "/widgets",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "WidgetDescriptor"
        ],
        "path": [
          "widgets"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/codePackages",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CodePackagesDescriptor"
        ],
        "path": [
          "codePackages"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/panels",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PanelDescriptor"
        ],
        "path": [
          "panels"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dashboards",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "DashboardDescriptor"
        ],
        "path": [
          "dashboards"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/customDefinitions",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomDefinitionDescriptor"
        ],
        "path": [
          "customDefinitions"
        ],
        "isRelationalSplit": false
      }
    ],
    "WidgetDescriptor": [
      {
        "jsonPointer": "/panels",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PanelDescriptor"
        ],
        "path": [
          "panels"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variations",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariationDescriptor"
        ],
        "path": [
          "variations"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presets",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PresetDescriptor"
        ],
        "path": [
          "presets"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/containedWidgets",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "containedWidgets"
        ],
        "isRelationalSplit": false
      }
    ],
    "DashboardDescriptor": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "PanelDescriptor": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariationDescriptor": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "PresetDescriptor": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "UnitSizeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$",
              "refTypes": [
                "UnitSizeVar"
              ]
            }
          ]
        }
      }
    ],
    "Image": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/originalImageDataRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "originalImageDataRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ImageA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageReference": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StripColumnsContainer": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StripColumnsContainerA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ClassicSection": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ClassicSectionA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StripContainer": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageList": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "AnchorLink": [
      {
        "jsonPointer": "/anchorDataId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "anchorDataId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "pageId"
        ],
        "isRelationalSplit": false
      }
    ],
    "DynamicPageLink": [
      {
        "jsonPointer": "/anchorDataId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "anchorDataId"
        ],
        "isRelationalSplit": false
      }
    ],
    "TpaPageLink": [
      {
        "jsonPointer": "/pageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "pageId"
        ],
        "isRelationalSplit": false
      }
    ],
    "PageLink": [
      {
        "jsonPointer": "/pageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "pageId"
        ],
        "isRelationalSplit": false
      }
    ],
    "MediaRichText": [
      {
        "jsonPointer": "/linkList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "linkList"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/componentDataList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "componentDataList"
        ],
        "isRelationalSplit": false
      }
    ],
    "Page": [
      {
        "jsonPointer": "/parentPageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "parentPageId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/desktop/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "desktop",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/mobile/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "mobile",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/ogImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "ogImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "RichTextImage": [
      {
        "jsonPointer": "/text",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "text"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/image",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "image"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextInput": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextInputA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "CheckboxInput": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "QuickActionBarItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "BasicMenuItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BasicMenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/iconRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VectorImage"
        ],
        "path": [
          "iconRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "CustomMenu": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BasicMenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "CustomMenusCollection": [
      {
        "jsonPointer": "/menus",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu",
          "Builder.MenuItems"
        ],
        "path": [
          "menus"
        ],
        "isRelationalSplit": false
      }
    ],
    "CustomMenuDataRef": [
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRefA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "Menu": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ImageButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/defaultImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "defaultImage"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/hoverImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "hoverImage"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/activeImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "activeImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "SubscribeForm": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContactForm": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "DynamicContactForm": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "FlashComponent": [
      {
        "jsonPointer": "/placeHolderImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "placeHolderImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "GeoMapLocation": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "GeoMap": [
      {
        "jsonPointer": "/locations",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GeoMapLocation"
        ],
        "path": [
          "locations"
        ],
        "isRelationalSplit": false
      }
    ],
    "LinkableFlashComponent": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/placeHolderImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "placeHolderImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "LinkableButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SiteButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "TinyMenu": [
      {
        "jsonPointer": "/loginSocialBarRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "LoginSocialBar"
        ],
        "path": [
          "loginSocialBarRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "LoginSocialBar": [
      {
        "jsonPointer": "/menuItemsRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRef"
        ],
        "path": [
          "menuItemsRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/iconItemsRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRef"
        ],
        "path": [
          "iconItemsRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "PagesGroupData": [
      {
        "jsonPointer": "/pages",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "pages"
        ],
        "isRelationalSplit": false
      }
    ],
    "PagesGroupCollection": [
      {
        "jsonPointer": "/groups",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "groups"
        ],
        "isRelationalSplit": false
      }
    ],
    "PermaLink": [
      {
        "jsonPointer": "/dataItemRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataItemRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/correctPermaLinkRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "correctPermaLinkRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "SelectableList": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SelectOption"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "RadioGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RadioButton"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "CheckboxGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CheckboxInput"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "StyledText": [
      {
        "jsonPointer": "/linkList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PageLink",
          "ExternalLink",
          "EmailLink",
          "AnchorLink",
          "DocumentLink",
          "PhoneLink",
          "DynamicPageLink",
          "TextLink",
          "LoginToWixLink",
          "WhatsAppLink",
          "AddressLink",
          "TpaPageLink"
        ],
        "path": [
          "linkList"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StyledTextA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StyledTextLinkHelper": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "SvgShape": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "VectorImage": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "Video": [
      {
        "jsonPointer": "/posterImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "posterImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPAWidget": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TPAData"
        ],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPA": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPASection": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TPAData"
        ],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPAMultiSection": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TPAData"
        ],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "RssButton": [
      {
        "jsonPointer": "/image",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "image"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "AppPage": [
      {
        "jsonPointer": "/parentPageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "parentPageId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/desktop/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "desktop",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/mobile/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "mobile",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/ogImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "ogImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "StripContainerSlideShowSlide": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      }
    ],
    "Repeater": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageButtonWithText": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      }
    ],
    "InternalRef": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "ForwardRef": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "LightboxContainer": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "LightboxA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContainerData": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContainerA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "MediaBoxData": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContainerA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "MultiStateBoxData": [
      {
        "jsonPointer": "/defaultStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "defaultStateId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/selectedStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "selectedStateId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MultiStateBoxDataA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StateBox": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StateBoxA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StateBoxState": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StateBoxStateA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.MenuItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Builder.MenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.MenuItems": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Builder.MenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.Video": [
      {
        "jsonPointer": "/poster",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Builder.Image"
        ],
        "path": [
          "poster"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.RichText": [
      {
        "jsonPointer": "/linkList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PageLink",
          "ExternalLink",
          "EmailLink",
          "AnchorLink",
          "DocumentLink",
          "PhoneLink",
          "DynamicPageLink",
          "TextLink",
          "LoginToWixLink",
          "WhatsAppLink",
          "AddressLink",
          "TpaPageLink"
        ],
        "path": [
          "linkList"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiButton": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiDatePicker": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/disabledDaysOfWeek",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "disabledDaysOfWeek"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/enabledDateRanges",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MobuiDateRangeType"
        ],
        "path": [
          "enabledDateRanges"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/disabledDateRanges",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MobuiDateRangeType"
        ],
        "path": [
          "disabledDateRanges"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/disabledDates",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "disabledDates"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiImage": [
      {
        "jsonPointer": "/src",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "src"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiPicker": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MobuiPickerItemType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiVideoPlayer": [
      {
        "jsonPointer": "/poster",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "poster"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiMultiStateBoxData": [
      {
        "jsonPointer": "/defaultStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "defaultStateId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/selectedStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "selectedStateId"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.Logo": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.ProductSpecification": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.ShareButtons": [
      {
        "jsonPointer": "/buttons",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "IShareButton"
        ],
        "path": [
          "buttons"
        ],
        "isRelationalSplit": false
      }
    ],
    "IShareButton": [
      {
        "jsonPointer": "/illustration",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "illustration"
        ],
        "isRelationalSplit": false
      }
    ],
    "BreadcrumbsData": [
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRefA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "CollapsibleTextData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "ComboBoxInputData": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SelectOption"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.FastGallery": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/wixSDKItems",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "wixSDKItems"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageX": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "MenuData": [
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRefA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.MenuList": [
      {
        "jsonPointer": "/menus",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "menus"
        ],
        "isRelationalSplit": false
      }
    ],
    "MusicPlayerData": [
      {
        "jsonPointer": "/audioRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "audioRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/coverRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "coverRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "Pagination": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PaginationA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "Section": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SectionA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "SelectionTagsList": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "SelectionTag": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "SiteButtonData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SiteButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StylableButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StylableButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "SvgImage": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.Tabs": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TabsA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextEffectsSharedData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextMarqueeData": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextMarqueeItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextMarqueeItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextFxData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextOnPathData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextParticlesData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "VideoPlayer": [
      {
        "jsonPointer": "/videoRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "videoRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/logoRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "logoRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.ControlTypes": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/thumbnails",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "thumbnails"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardIconButton": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardInfoIcon": [
      {
        "jsonPointer": "/tooltipLink",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "tooltipLink"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardInput": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardNumberInput": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardTextButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuButton": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuCheckboxGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuColumnControllerControl": [
      {
        "jsonPointer": "/columns",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "columns"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuDropdown": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuEmptyState": [
      {
        "jsonPointer": "/illustration",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "illustration"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuHorizontalTabs": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuLeftTextButton": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuRadioButtonGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuRichText": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuThumbnails": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ThumbnailItemData"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "ThumbnailItemData": [
      {
        "jsonPointer": "/illustration",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "illustration"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WutAvatarGroup": [
      {
        "jsonPointer": "/avatars",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "avatars"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WutBadge": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "design_data.json": {
    "MediaContainerDesignData": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BackgroundMedia"
        ],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      }
    ],
    "MediaContainerWithDividers": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BackgroundMedia"
        ],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dividerTop",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ShapeDivider"
        ],
        "path": [
          "dividerTop"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dividerBottom",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ShapeDivider"
        ],
        "path": [
          "dividerBottom"
        ],
        "isRelationalSplit": false
      }
    ],
    "MediaPlayerDesignData": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BackgroundMedia"
        ],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextFxMask": [
      {
        "jsonPointer": "/media",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BackgroundMedia"
        ],
        "path": [
          "media"
        ],
        "isRelationalSplit": false
      }
    ],
    "BackgroundMedia": [
      {
        "jsonPointer": "/mediaRef",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image",
          "WixVideo"
        ],
        "path": [
          "mediaRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/imageOverlay",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "imageOverlay"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/colorLayers",
        "isList": true,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GradientLinearLayer",
          "GradientCircleLayer",
          "GradientEllipseLayer",
          "GradientConicLayer",
          "GradientMeshLayer",
          "SolidColorLayer"
        ],
        "path": [
          "colorLayers"
        ],
        "isRelationalSplit": false
      }
    ],
    "WixVideo": [
      {
        "jsonPointer": "/posterImageRef",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "posterImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "Video": [
      {
        "jsonPointer": "/posterImage",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "posterImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "Image": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/originalImageDataRef",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "originalImageDataRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "MediaControlsDesignData": [
      {
        "jsonPointer": "/iconsDefaultDesign",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VectorImageDesignData"
        ],
        "path": [
          "iconsDefaultDesign"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/icons",
        "isList": true,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ControlIconDesignData"
        ],
        "path": [
          "icons"
        ],
        "isRelationalSplit": false
      }
    ],
    "ControlIconDesignData": [
      {
        "jsonPointer": "/iconDesign",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VectorImageDesignData"
        ],
        "path": [
          "iconDesign"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "discussions.json": {
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "effects.json": {
    "EffectsList": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TimeAnimation",
          "ScrubAnimation",
          "CanvasAnimation"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "CanvasAnimation": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CanvasAnimationOptions",
          "TimeAnimationOptions",
          "ScrubAnimationOptions"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "CanvasAnimationOptions": [
      {
        "jsonPointer": "/namedEffect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Kaleidoscope",
          "RGBSplit",
          "RGBOrb",
          "SlitScan",
          "NoisyTrack",
          "Smear",
          "Ripples"
        ],
        "path": [
          "namedEffect"
        ],
        "isRelationalSplit": false
      }
    ],
    "TimeAnimationOptions": [
      {
        "jsonPointer": "/keyframeEffect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "KeyframeEffect"
        ],
        "path": [
          "keyframeEffect"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namedEffect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ArcIn",
          "DropIn",
          "ExpandIn",
          "FadeIn",
          "FlipIn",
          "FloatIn",
          "FlyIn",
          "FoldIn",
          "RevealIn",
          "SlideIn",
          "SpinIn",
          "TurnIn",
          "BounceIn",
          "GlideIn",
          "GlitchIn",
          "TiltIn",
          "ShapeIn",
          "ShuttersIn",
          "WinkIn",
          "GrowIn",
          "BlurIn",
          "PunchIn",
          "CurveIn",
          "CircleIn",
          "Breathe",
          "Blink",
          "Pulse",
          "Spin",
          "Poke",
          "Flash",
          "Swing",
          "Flip",
          "Rubber",
          "Fold",
          "Jello",
          "Wiggle",
          "Bounce",
          "DVD",
          "Cross",
          "ArcScroll",
          "BlurScroll",
          "FadeScroll",
          "FlipScroll",
          "GrowScroll",
          "MoveScroll",
          "PanScroll",
          "ParallaxScroll",
          "RevealScroll",
          "ShapeScroll",
          "ShrinkScroll",
          "ShuttersScroll",
          "SkewPanScroll",
          "SlideScroll",
          "Spin3dScroll",
          "StretchScroll",
          "SpinScroll",
          "TiltScroll",
          "TurnScroll",
          "TrackMouse",
          "Tilt3DMouse",
          "SwivelMouse",
          "BlobMouse",
          "ScaleMouse",
          "Track3DMouse",
          "AiryMouse",
          "BlurMouse",
          "SkewMouse",
          "BgCloseUp",
          "BgFade",
          "BgFadeBack",
          "BgFake3D",
          "BgPan",
          "BgParallax",
          "BgPullBack",
          "BgReveal",
          "BgRotate",
          "BgSkew",
          "BgZoom",
          "ImageParallax"
        ],
        "path": [
          "namedEffect"
        ],
        "isRelationalSplit": false
      }
    ],
    "TimeAnimation": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TimeAnimationOptions"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "ScrubAnimationOptions": [
      {
        "jsonPointer": "/keyframeEffect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "KeyframeEffect"
        ],
        "path": [
          "keyframeEffect"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namedEffect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ArcIn",
          "DropIn",
          "ExpandIn",
          "FadeIn",
          "FlipIn",
          "FloatIn",
          "FlyIn",
          "FoldIn",
          "RevealIn",
          "SlideIn",
          "SpinIn",
          "TurnIn",
          "BounceIn",
          "GlideIn",
          "GlitchIn",
          "TiltIn",
          "ShapeIn",
          "ShuttersIn",
          "WinkIn",
          "GrowIn",
          "BlurIn",
          "PunchIn",
          "CurveIn",
          "CircleIn",
          "Breathe",
          "Blink",
          "Pulse",
          "Spin",
          "Poke",
          "Flash",
          "Swing",
          "Flip",
          "Rubber",
          "Fold",
          "Jello",
          "Wiggle",
          "Bounce",
          "DVD",
          "Cross",
          "ArcScroll",
          "BlurScroll",
          "FadeScroll",
          "FlipScroll",
          "GrowScroll",
          "MoveScroll",
          "PanScroll",
          "ParallaxScroll",
          "RevealScroll",
          "ShapeScroll",
          "ShrinkScroll",
          "ShuttersScroll",
          "SkewPanScroll",
          "SlideScroll",
          "Spin3dScroll",
          "StretchScroll",
          "SpinScroll",
          "TiltScroll",
          "TurnScroll",
          "TrackMouse",
          "Tilt3DMouse",
          "SwivelMouse",
          "BlobMouse",
          "ScaleMouse",
          "Track3DMouse",
          "AiryMouse",
          "BlurMouse",
          "SkewMouse",
          "BgCloseUp",
          "BgFade",
          "BgFadeBack",
          "BgFake3D",
          "BgPan",
          "BgParallax",
          "BgPullBack",
          "BgReveal",
          "BgRotate",
          "BgSkew",
          "BgZoom",
          "ImageParallax"
        ],
        "path": [
          "namedEffect"
        ],
        "isRelationalSplit": false
      }
    ],
    "ScrubAnimation": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ScrubAnimationOptions"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "AnimationCommonOptions": [
      {
        "jsonPointer": "/keyframeEffect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "KeyframeEffect"
        ],
        "path": [
          "keyframeEffect"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namedEffect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ArcIn",
          "DropIn",
          "ExpandIn",
          "FadeIn",
          "FlipIn",
          "FloatIn",
          "FlyIn",
          "FoldIn",
          "RevealIn",
          "SlideIn",
          "SpinIn",
          "TurnIn",
          "BounceIn",
          "GlideIn",
          "GlitchIn",
          "TiltIn",
          "ShapeIn",
          "ShuttersIn",
          "WinkIn",
          "GrowIn",
          "BlurIn",
          "PunchIn",
          "CurveIn",
          "CircleIn",
          "Breathe",
          "Blink",
          "Pulse",
          "Spin",
          "Poke",
          "Flash",
          "Swing",
          "Flip",
          "Rubber",
          "Fold",
          "Jello",
          "Wiggle",
          "Bounce",
          "DVD",
          "Cross",
          "ArcScroll",
          "BlurScroll",
          "FadeScroll",
          "FlipScroll",
          "GrowScroll",
          "MoveScroll",
          "PanScroll",
          "ParallaxScroll",
          "RevealScroll",
          "ShapeScroll",
          "ShrinkScroll",
          "ShuttersScroll",
          "SkewPanScroll",
          "SlideScroll",
          "Spin3dScroll",
          "StretchScroll",
          "SpinScroll",
          "TiltScroll",
          "TurnScroll",
          "TrackMouse",
          "Tilt3DMouse",
          "SwivelMouse",
          "BlobMouse",
          "ScaleMouse",
          "Track3DMouse",
          "AiryMouse",
          "BlurMouse",
          "SkewMouse",
          "BgCloseUp",
          "BgFade",
          "BgFadeBack",
          "BgFake3D",
          "BgPan",
          "BgParallax",
          "BgPullBack",
          "BgReveal",
          "BgRotate",
          "BgSkew",
          "BgZoom",
          "ImageParallax"
        ],
        "path": [
          "namedEffect"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "innerElements.json": {
    "InnerElementQueries": [
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ],
    "InnerElement": [
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ]
  },
  "layout_data.json": {
    "LayoutData": [
      {
        "jsonPointer": "/componentLayouts",
        "isList": true,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "componentLayouts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/itemLayouts",
        "isList": true,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "itemLayouts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/containerLayouts",
        "isList": true,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "containerLayouts"
        ],
        "isRelationalSplit": false
      }
    ],
    "SingleLayoutData": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "LayoutSizeVar",
          "UnitSizeVar",
          "HeightVar",
          "PositionTypeVar",
          "NumberVar",
          "ItemsAlignmentVar",
          "KeywordLengthVar",
          "JustifyContentVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$",
              "refTypes": [
                "LayoutSizeVar"
              ]
            },
            {
              "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/contentMaxWidth\\/maxWidth|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right)$",
              "refTypes": [
                "UnitSizeVar"
              ]
            },
            {
              "pattern": "^(?:componentLayout\\/height)$",
              "refTypes": [
                "HeightVar"
              ]
            },
            {
              "pattern": "^(?:itemLayout\\/position|containerLayout\\/position)$",
              "refTypes": [
                "PositionTypeVar"
              ]
            },
            {
              "pattern": "^(?:itemLayout\\/gridArea\\/rowStart|itemLayout\\/gridArea\\/columnStart|itemLayout\\/gridArea\\/rowEnd|itemLayout\\/gridArea\\/columnEnd|containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$",
              "refTypes": [
                "NumberVar"
              ]
            },
            {
              "pattern": "^(?:itemLayout\\/alignSelf|itemLayout\\/justifySelf|containerLayout\\/alignItems)$",
              "refTypes": [
                "ItemsAlignmentVar"
              ]
            },
            {
              "pattern": "^(?:containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$",
              "refTypes": [
                "KeywordLengthVar"
              ]
            },
            {
              "pattern": "^(?:containerLayout\\/justifyContent)$",
              "refTypes": [
                "JustifyContentVar"
              ]
            }
          ]
        }
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "layoutSettings.json": {
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "patterns.json": {
    "Pattern": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "NthChild"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "NthChild": [
      {
        "jsonPointer": "/variant",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPattern"
        ],
        "path": [
          "variant"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "presets.json": {
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "component_properties.json": {
    "ColumnProperties": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "reactions.json": {
    "Reactions": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ToggleState",
          "RemoveState",
          "AddState",
          "RemoveAllStates",
          "ScrollForward",
          "ScrollBackward",
          "Play",
          "Scrub",
          "TogglePlay"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "BaseStateReaction": [
      {
        "jsonPointer": "/state",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "State"
        ],
        "path": [
          "state"
        ],
        "isRelationalSplit": false
      }
    ],
    "ToggleState": [
      {
        "jsonPointer": "/state",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "State"
        ],
        "path": [
          "state"
        ],
        "isRelationalSplit": false
      }
    ],
    "RemoveState": [
      {
        "jsonPointer": "/state",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "State"
        ],
        "path": [
          "state"
        ],
        "isRelationalSplit": false
      }
    ],
    "AddState": [
      {
        "jsonPointer": "/state",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "State"
        ],
        "path": [
          "state"
        ],
        "isRelationalSplit": false
      }
    ],
    "Play": [
      {
        "jsonPointer": "/effect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TimeAnimation"
        ],
        "path": [
          "effect"
        ],
        "isRelationalSplit": false
      }
    ],
    "TogglePlay": [
      {
        "jsonPointer": "/effect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TimeAnimation"
        ],
        "path": [
          "effect"
        ],
        "isRelationalSplit": false
      }
    ],
    "Scrub": [
      {
        "jsonPointer": "/effect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "ScrubAnimation"
        ],
        "path": [
          "effect"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "slots.json": {
    "PlaceholderSlot": [
      {
        "jsonPointer": "/slots/slot",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "slots",
          "slot"
        ],
        "isRelationalSplit": false
      }
    ],
    "SlotRef": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "states.json": {
    "States": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "State"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false,
        "dontSerialize": true
      }
    ]
  },
  "structure.json": {
    "DesignQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "DataQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PropertyQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StyleId": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "MobileHintsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BehaviorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ConnectionQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ControllersQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "LayoutQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "AnchorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BreakpointVariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "TransformationQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "TransitionQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "Bindings": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ContextsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ModesDefinition": [
      {
        "jsonPointer": "/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ],
    "BaseComponentObject": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      }
    ],
    "ComponentsList": [
      {
        "jsonPointer": "/",
        "isList": true,
        "referencedMap": "structure",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "Component": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ],
    "ComponentQueries": [
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefComponent": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "structure",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterContainer": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList",
          "RepeaterPatternList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "structure",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/patternsQuery",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "patternsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterVariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPatternList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterQueries": [
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPatternList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/patternsQuery",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "patternsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContainerQueries": [
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      }
    ],
    "Container": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "structure",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      }
    ],
    "PageQueries": [
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Page": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "structure",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "DocumentProperties": [
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/themeConfigQuery",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "themeConfigQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Document": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "structure",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/themeConfigQuery",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "themeConfigQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Parent": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "structure",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "AccessibilityQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ClassnamesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ContentRoleQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "CursorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "DiscussionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "EditorsettingsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "EffectsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "FixerVersionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "GroupingQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "InnerElementsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "IntentQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "LayoutSettingsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ManifestQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "MeasurementsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "MigrationQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "NamingQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "NotificationsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PageSectionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PatternsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PresetsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ReactionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "SlotsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "SourceQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StatesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ThemeConfigQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "TriggersQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "VariablesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "theme_data.json": {
    "TopLevelStyle": [
      {
        "jsonPointer": "/style/background/gradient",
        "isList": true,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GradientLinearLayer",
          "GradientCircleLayer",
          "GradientEllipseLayer",
          "GradientConicLayer",
          "GradientMeshLayer",
          "SolidColorLayer"
        ],
        "path": [
          "style",
          "background",
          "gradient"
        ],
        "isRelationalSplit": false
      }
    ],
    "ComponentStyle": [
      {
        "jsonPointer": "/style/background/gradient",
        "isList": true,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GradientLinearLayer",
          "GradientCircleLayer",
          "GradientEllipseLayer",
          "GradientConicLayer",
          "GradientMeshLayer",
          "SolidColorLayer"
        ],
        "path": [
          "style",
          "background",
          "gradient"
        ],
        "isRelationalSplit": false
      }
    ],
    "GlobalStylesCollection": [
      {
        "jsonPointer": "/styles",
        "isList": true,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "styles"
        ],
        "isRelationalSplit": false
      }
    ],
    "GlobalStyle": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "StyleObjectDefinition": [
      {
        "jsonPointer": "/style/background/gradient",
        "isList": true,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GradientLinearLayer",
          "GradientCircleLayer",
          "GradientEllipseLayer",
          "GradientConicLayer",
          "GradientMeshLayer",
          "SolidColorLayer"
        ],
        "path": [
          "style",
          "background",
          "gradient"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "transformations_data.json": {
    "TransformData": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "UnitSizeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:translate\\/x|translate\\/y|origin\\/x|origin\\/y)$",
              "refTypes": [
                "UnitSizeVar"
              ]
            }
          ]
        }
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "transitions_data.json": {
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "triggers.json": {
    "Triggers": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Trigger"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false,
        "dontSerialize": true
      }
    ]
  },
  "variables.json": {
    "VariablesList": [
      {
        "jsonPointer": "/variables",
        "isList": true,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "UnitSizeVar",
          "NumberVar",
          "ItemsAlignmentVar",
          "JustifyContentVar",
          "PositionTypeVar",
          "LayoutSizeVar",
          "HeightVar",
          "KeywordLengthVar",
          "NumVar",
          "LengthVar",
          "PositiveLengthVar",
          "AngleVar",
          "ColorVar",
          "PercentageVar",
          "BorderEdgeStyleVar",
          "BorderEdgeWidthVar",
          "BorderWidthVar",
          "BorderStyleVar",
          "BorderColorVar",
          "BorderVar",
          "BorderCornerRadiusVar",
          "BorderRadiusVar",
          "FontVar",
          "FontSizeVar",
          "FontStretchVar",
          "FontStyleVar",
          "FontVariantVar",
          "FontWeightVar",
          "FontFamilyVar",
          "LineHeightVar",
          "LetterSpacingVar",
          "TextAlignVar",
          "TextTransformVar",
          "TextShadowVar",
          "TextDecorationVar",
          "TextDecorationLineVar",
          "TextDecorationStyleVar",
          "TextDecorationThicknessVar",
          "TextIndentVar",
          "PaddingVar",
          "PaddingEdgeVar",
          "MarginVar",
          "MarginEdgeVar",
          "BoxShadowVar",
          "OpacityVar",
          "CssJustifyContentVar",
          "BackgroundVar",
          "WritingModeVar",
          "DisplayVar",
          "FilterVar",
          "GapVar",
          "SingleValueGapVar"
        ],
        "path": [
          "variables"
        ],
        "isRelationalSplit": false
      }
    ],
    "UnitSizeVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "UnitSizeValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "UnitSizeValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "UnitSizeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "UnitSizeVar"
              ]
            }
          ]
        }
      }
    ],
    "NumberVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "NumberValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "NumberValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "NumberVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "NumberVar"
              ]
            }
          ]
        }
      }
    ],
    "ItemsAlignmentVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ItemsAlignmentValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "ItemsAlignmentValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "ItemsAlignmentVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "ItemsAlignmentVar"
              ]
            }
          ]
        }
      }
    ],
    "JustifyContentVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "JustifyContentValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "JustifyContentValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "JustifyContentVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "JustifyContentVar"
              ]
            }
          ]
        }
      }
    ],
    "PositionTypeVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PositionTypeValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "PositionTypeValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PositionTypeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositionTypeVar"
              ]
            }
          ]
        }
      }
    ],
    "LayoutSizeVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "LayoutSizeValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "LayoutSizeValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "LayoutSizeVar",
          "UnitSizeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LayoutSizeVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "UnitSizeVar"
              ]
            }
          ]
        }
      }
    ],
    "HeightVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "HeightValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "HeightValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "HeightVar",
          "LayoutSizeVar",
          "UnitSizeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "HeightVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LayoutSizeVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "UnitSizeVar"
              ]
            }
          ]
        }
      }
    ],
    "KeywordLengthVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "KeywordLengthValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "KeywordLengthValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "KeywordLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "KeywordLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "NumVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "NumValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "NumValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "NumVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "NumVar"
              ]
            }
          ]
        }
      }
    ],
    "LengthVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "LengthValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "LengthValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "LengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LengthVar"
              ]
            }
          ]
        }
      }
    ],
    "PositiveLengthVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PositiveLengthValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "PositiveLengthValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "AngleVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "AngleValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "AngleValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "AngleVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "AngleVar"
              ]
            }
          ]
        }
      }
    ],
    "ColorVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ColorValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "ColorValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "ColorVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "ColorVar"
              ]
            }
          ]
        }
      }
    ],
    "PercentageVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PercentageValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "PercentageValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PercentageVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PercentageVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderEdgeStyleVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderEdgeStyleValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderEdgeStyleValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderEdgeStyleVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderEdgeStyleVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderEdgeWidthVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderEdgeWidthValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderEdgeWidthValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderEdgeWidthVar",
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderEdgeWidthVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderWidthVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderWidthValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderWidthValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderWidthVar",
          "LengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderWidthVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LengthVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderStyleVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderStyleValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderStyleValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderStyleVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderStyleVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderColorVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderColorValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderColorValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderColorVar",
          "ColorVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderColorVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "ColorVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderCornerRadiusVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderCornerRadiusValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderCornerRadiusValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderCornerRadiusVar",
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderCornerRadiusVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "BorderRadiusVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BorderRadiusValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BorderRadiusValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BorderRadiusVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BorderRadiusVar"
              ]
            }
          ]
        }
      }
    ],
    "FontVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FontValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FontValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FontVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FontVar"
              ]
            }
          ]
        }
      }
    ],
    "FontSizeVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FontSizeValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FontSizeValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FontSizeVar",
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FontSizeVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "FontStretchVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FontStretchValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FontStretchValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FontStretchVar",
          "PercentageVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FontStretchVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PercentageVar"
              ]
            }
          ]
        }
      }
    ],
    "FontStyleVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FontStyleValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FontStyleValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FontStyleVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FontStyleVar"
              ]
            }
          ]
        }
      }
    ],
    "FontVariantVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FontVariantValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FontVariantValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FontVariantVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FontVariantVar"
              ]
            }
          ]
        }
      }
    ],
    "FontWeightVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FontWeightValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FontWeightValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FontWeightVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FontWeightVar"
              ]
            }
          ]
        }
      }
    ],
    "FontFamilyVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FontFamilyValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FontFamilyValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FontFamilyVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FontFamilyVar"
              ]
            }
          ]
        }
      }
    ],
    "LineHeightVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "LineHeightValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "LineHeightValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "LineHeightVar",
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LineHeightVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "LetterSpacingVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "LetterSpacingValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "LetterSpacingValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "LetterSpacingVar",
          "LengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LetterSpacingVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LengthVar"
              ]
            }
          ]
        }
      }
    ],
    "TextAlignVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextAlignValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextAlignValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextAlignVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextAlignVar"
              ]
            }
          ]
        }
      }
    ],
    "TextTransformVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextTransformValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextTransformValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextTransformVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextTransformVar"
              ]
            }
          ]
        }
      }
    ],
    "TextShadowVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextShadowValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextShadowValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextShadowVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextShadowVar"
              ]
            }
          ]
        }
      }
    ],
    "TextDecorationVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextDecorationValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextDecorationVar"
              ]
            }
          ]
        }
      }
    ],
    "TextDecorationLineVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationLineValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextDecorationLineValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationLineVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextDecorationLineVar"
              ]
            }
          ]
        }
      }
    ],
    "TextDecorationStyleVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationStyleValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextDecorationStyleValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationStyleVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextDecorationStyleVar"
              ]
            }
          ]
        }
      }
    ],
    "TextDecorationThicknessVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationThicknessValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextDecorationThicknessValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextDecorationThicknessVar",
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextDecorationThicknessVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "TextIndentVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextIndentValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "TextIndentValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TextIndentVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "TextIndentVar"
              ]
            }
          ]
        }
      }
    ],
    "PaddingVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PaddingValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "PaddingValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PaddingVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PaddingVar"
              ]
            }
          ]
        }
      }
    ],
    "PaddingEdgeVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PaddingEdgeValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "PaddingEdgeValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PaddingEdgeVar",
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PaddingEdgeVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "MarginVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MarginValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "MarginValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "MarginVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "MarginVar"
              ]
            }
          ]
        }
      }
    ],
    "MarginEdgeVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MarginEdgeValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "MarginEdgeValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "MarginEdgeVar",
          "LengthVar",
          "PercentageVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "MarginEdgeVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "LengthVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PercentageVar"
              ]
            }
          ]
        }
      }
    ],
    "BoxShadowVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BoxShadowValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BoxShadowValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BoxShadowVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BoxShadowVar"
              ]
            }
          ]
        }
      }
    ],
    "OpacityVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "OpacityValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "OpacityValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "OpacityVar",
          "NumVar",
          "PercentageVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "OpacityVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "NumVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PercentageVar"
              ]
            }
          ]
        }
      }
    ],
    "CssJustifyContentVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CssJustifyContentValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "CssJustifyContentValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "CssJustifyContentVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "CssJustifyContentVar"
              ]
            }
          ]
        }
      }
    ],
    "BackgroundVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BackgroundValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "BackgroundValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "BackgroundVar",
          "ColorVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "BackgroundVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "ColorVar"
              ]
            }
          ]
        }
      }
    ],
    "WritingModeVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "WritingModeValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "WritingModeValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "WritingModeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "WritingModeVar"
              ]
            }
          ]
        }
      }
    ],
    "DisplayVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "DisplayValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "DisplayValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "DisplayVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "DisplayVar"
              ]
            }
          ]
        }
      }
    ],
    "FilterVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "FilterValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "FilterValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "FilterVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "FilterVar"
              ]
            }
          ]
        }
      }
    ],
    "GapVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GapValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "GapValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "GapVar",
          "PositiveLengthVar",
          "SingleValueGapVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "GapVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "SingleValueGapVar"
              ]
            }
          ]
        }
      }
    ],
    "SingleValueGapVar": [
      {
        "jsonPointer": "/value",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SingleValueGapValue"
        ],
        "path": [
          "value"
        ],
        "isRelationalSplit": true
      }
    ],
    "SingleValueGapValue": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "SingleValueGapVar",
          "PositiveLengthVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "SingleValueGapVar"
              ]
            },
            {
              "pattern": "^(?:value)$",
              "refTypes": [
                "PositiveLengthVar"
              ]
            }
          ]
        }
      }
    ],
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "variants_data.json": {
    "Trigger": [
      {
        "jsonPointer": "/params/effect",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "TimeAnimation"
        ],
        "path": [
          "params",
          "effect"
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterPatternList": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPattern"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantsList": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "BreakpointsData": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BreakpointRange"
        ],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namedRanges",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "NamedRange"
        ],
        "path": [
          "namedRanges"
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "commonSchemas.json": {
    "RefArray": [
      {
        "jsonPointer": "/values",
        "isList": true,
        "referencedMap": "commonSchemas",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "values"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantRelation": [
      {
        "jsonPointer": "/variants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Hover",
          "Mobile",
          "State",
          "Selected",
          "Trigger",
          "Preset",
          "RepeaterPattern",
          "BreakpointRange",
          "NamedRange"
        ],
        "path": [
          "variants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/remoteVariants",
        "isList": true,
        "referencedMap": "variants_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "remoteVariants"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/to",
        "isList": false,
        "referencedMap": "commonSchemas",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "to"
        ],
        "isRelationalSplit": false
      }
    ],
    "LinkReference": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "commonSchemas",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "Common_Image": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "commonSchemas",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/originalImageDataRef",
        "isList": false,
        "referencedMap": "commonSchemas",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "originalImageDataRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "ColorLayers": [
      {
        "jsonPointer": "/",
        "isList": true,
        "referencedMap": "commonSchemas",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GradientLinearLayer",
          "GradientCircleLayer",
          "GradientEllipseLayer",
          "GradientConicLayer",
          "GradientMeshLayer",
          "SolidColorLayer"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "DESKTOP.json": {
    "DesignQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "DataQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PropertyQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StyleId": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "MobileHintsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BehaviorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ConnectionQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ControllersQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "LayoutQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "AnchorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BreakpointVariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "TransformationQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "TransitionQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "Bindings": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ContextsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ModesDefinition": [
      {
        "jsonPointer": "/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ],
    "BaseComponentObject": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      }
    ],
    "ComponentsList": [
      {
        "jsonPointer": "/",
        "isList": true,
        "referencedMap": "DESKTOP",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "Component": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ],
    "ComponentQueries": [
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefComponent": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "DESKTOP",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterContainer": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList",
          "RepeaterPatternList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "DESKTOP",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/patternsQuery",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "patternsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterVariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPatternList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterQueries": [
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPatternList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/patternsQuery",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "patternsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContainerQueries": [
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      }
    ],
    "Container": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "DESKTOP",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      }
    ],
    "PageQueries": [
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Page": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "DESKTOP",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "DocumentProperties": [
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/themeConfigQuery",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "themeConfigQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Document": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "DESKTOP",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/themeConfigQuery",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "themeConfigQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Parent": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "AccessibilityQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ClassnamesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ContentRoleQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "CursorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "DiscussionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "EditorsettingsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "EffectsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "FixerVersionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "GroupingQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "InnerElementsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "IntentQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "LayoutSettingsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ManifestQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "MeasurementsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "MigrationQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "NamingQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "NotificationsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PageSectionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PatternsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PresetsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ReactionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "SlotsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "SourceQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StatesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ThemeConfigQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "TriggersQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "VariablesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "MOBILE.json": {
    "DesignQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "DataQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PropertyQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "VariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StyleId": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "MobileHintsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BehaviorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ConnectionQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ControllersQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "LayoutQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "AnchorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BreakpointVariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "TransformationQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "TransitionQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "Bindings": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ContextsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ModesDefinition": [
      {
        "jsonPointer": "/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ],
    "BaseComponentObject": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      }
    ],
    "ComponentsList": [
      {
        "jsonPointer": "/",
        "isList": true,
        "referencedMap": "MOBILE",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "Component": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      }
    ],
    "ComponentQueries": [
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "RefComponent": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "MOBILE",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterContainer": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList",
          "RepeaterPatternList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "MOBILE",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/patternsQuery",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "patternsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterVariantsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPatternList"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "RepeaterQueries": [
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterPatternList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/patternsQuery",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "patternsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContainerQueries": [
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      }
    ],
    "Container": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "MOBILE",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      }
    ],
    "PageQueries": [
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Page": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "MOBILE",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "DocumentProperties": [
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/themeConfigQuery",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "themeConfigQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Document": [
      {
        "jsonPointer": "/parent",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "parent"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dataQuery",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/mobileHintsQuery",
        "isList": false,
        "referencedMap": "mobile_hints",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "mobileHintsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/behaviorQuery",
        "isList": false,
        "referencedMap": "behaviors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "behaviorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/connectionQuery",
        "isList": false,
        "referencedMap": "connections_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "connectionQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/controllersQuery",
        "isList": false,
        "referencedMap": "controllers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "controllersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutQuery",
        "isList": false,
        "referencedMap": "layout_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/anchorQuery",
        "isList": false,
        "referencedMap": "anchors_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "anchorQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/breakpointVariantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "breakpointVariantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/transformationQuery",
        "isList": false,
        "referencedMap": "transformations_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transformationQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/transitionQuery",
        "isList": false,
        "referencedMap": "transitions_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "transitionQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/variantsQuery",
        "isList": false,
        "referencedMap": "variants_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariantsList"
        ],
        "path": [
          "variantsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/bindings",
        "isList": false,
        "referencedMap": "bindings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BindingsList"
        ],
        "path": [
          "bindings"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/accessibilityQuery",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "accessibilityQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/classnamesQuery",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "classnamesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/contentRoleQuery",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "contentRoleQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/cursorQuery",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "cursorQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/discussionsQuery",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "discussionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/editorsettingsQuery",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "editorsettingsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/effectsQuery",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "effectsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/groupingQuery",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "groupingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/innerElementsQuery",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "innerElementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/intentQuery",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "intentQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/layoutSettingsQuery",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "layoutSettingsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/manifestQuery",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "manifestQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/measurementsQuery",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "measurementsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/migrationQuery",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "migrationQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/namingQuery",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "namingQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/notificationsQuery",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "notificationsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageSectionsQuery",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageSectionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presetsQuery",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "presetsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/reactionsQuery",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "reactionsQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/slotsQuery",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "slotsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/sourceQuery",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "sourceQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/statesQuery",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "statesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/triggersQuery",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "triggersQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variablesQuery",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "variablesQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/definitions/settings/pagesGroupId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "modes",
          "definitions",
          "settings",
          "pagesGroupId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/designQuery",
        "isList": false,
        "referencedMap": "design_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "designQuery"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/modes/overrides/propertyQuery",
        "isList": false,
        "referencedMap": "component_properties",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "propertyQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/modes/overrides/styleId",
        "isList": false,
        "referencedMap": "theme_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "modes",
          "overrides",
          "styleId"
        ],
        "isRelationalSplit": true
      },
      {
        "jsonPointer": "/contexts",
        "isList": false,
        "referencedMap": "contexts",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContextsList"
        ],
        "path": [
          "contexts"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/components",
        "isList": true,
        "referencedMap": "MOBILE",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "components"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/fixerVersionsQuery",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "fixerVersionsQuery"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/themeConfigQuery",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "themeConfigQuery"
        ],
        "isRelationalSplit": false
      }
    ],
    "Parent": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "MOBILE",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "AccessibilityQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "accessibility",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ClassnamesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "classnames",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ContentRoleQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "contentRole",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "CursorQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "cursor",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "DiscussionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "discussions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "EditorsettingsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "editorsettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "EffectsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "effects",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "FixerVersionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "fixerVersions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "GroupingQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "grouping",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "InnerElementsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "innerElements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "IntentQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "intent",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "LayoutSettingsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "layoutSettings",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ManifestQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "manifest",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "MeasurementsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "measurements",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "MigrationQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "migration",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "NamingQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "naming",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "NotificationsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "notifications",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PageSectionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "pageSections",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PatternsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "patterns",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "PresetsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "presets",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "ReactionsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "reactions",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": true
      }
    ],
    "SlotsQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "slots",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "SourceQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "source",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StatesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "states",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "ThemeConfigQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "themeConfig",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "TriggersQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "triggers",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "VariablesQuery": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ]
  },
  "multilingualTranslations.json": {
    "SVGReference": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "BackgroundMedia": [
      {
        "jsonPointer": "/mediaRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image",
          "WixVideo"
        ],
        "path": [
          "mediaRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/imageOverlay",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "imageOverlay"
        ],
        "isRelationalSplit": false
      }
    ],
    "WixVideo": [
      {
        "jsonPointer": "/posterImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "posterImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "WixVideoData": [
      {
        "jsonPointer": "/posterImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "posterImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "Document": [
      {
        "jsonPointer": "/mainPage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "mainPage"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/smSettings/termsOfUse/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "smSettings",
          "termsOfUse",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/smSettings/privacyPolicy/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "smSettings",
          "privacyPolicy",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/smSettings/codeOfConduct/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "smSettings",
          "codeOfConduct",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/appStudioData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "AppStudioData"
        ],
        "path": [
          "appStudioData"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/appsInstallState",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "AppsInstallState"
        ],
        "path": [
          "appsInstallState"
        ],
        "isRelationalSplit": false
      }
    ],
    "SiteMembersData": [
      {
        "jsonPointer": "/termsOfUse/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "termsOfUse",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/privacyPolicy/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "privacyPolicy",
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/codeOfConduct/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "codeOfConduct",
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "AppStudioData": [
      {
        "jsonPointer": "/widgets",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "WidgetDescriptor"
        ],
        "path": [
          "widgets"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/codePackages",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CodePackagesDescriptor"
        ],
        "path": [
          "codePackages"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/panels",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PanelDescriptor"
        ],
        "path": [
          "panels"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/dashboards",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "DashboardDescriptor"
        ],
        "path": [
          "dashboards"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/customDefinitions",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomDefinitionDescriptor"
        ],
        "path": [
          "customDefinitions"
        ],
        "isRelationalSplit": false
      }
    ],
    "WidgetDescriptor": [
      {
        "jsonPointer": "/panels",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PanelDescriptor"
        ],
        "path": [
          "panels"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/variations",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VariationDescriptor"
        ],
        "path": [
          "variations"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/presets",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PresetDescriptor"
        ],
        "path": [
          "presets"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/containedWidgets",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "containedWidgets"
        ],
        "isRelationalSplit": false
      }
    ],
    "DashboardDescriptor": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "PanelDescriptor": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "VariationDescriptor": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "PresetDescriptor": [
      {
        "jsonPointer": "/variableConnections/variableId",
        "isList": false,
        "referencedMap": "variables",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "UnitSizeVar"
        ],
        "path": [
          "variableConnections",
          "variableId"
        ],
        "isRelationalSplit": false,
        "variableTypesByPattern": {
          "items": [
            {
              "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$",
              "refTypes": [
                "UnitSizeVar"
              ]
            }
          ]
        }
      }
    ],
    "Image": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/originalImageDataRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "originalImageDataRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ImageA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageReference": [
      {
        "jsonPointer": "/",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          ""
        ],
        "isRelationalSplit": false
      }
    ],
    "StripColumnsContainer": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StripColumnsContainerA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ClassicSection": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ClassicSectionA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StripContainer": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageList": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "AnchorLink": [
      {
        "jsonPointer": "/anchorDataId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "anchorDataId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "pageId"
        ],
        "isRelationalSplit": false
      }
    ],
    "DynamicPageLink": [
      {
        "jsonPointer": "/anchorDataId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "anchorDataId"
        ],
        "isRelationalSplit": false
      }
    ],
    "TpaPageLink": [
      {
        "jsonPointer": "/pageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "pageId"
        ],
        "isRelationalSplit": false
      }
    ],
    "PageLink": [
      {
        "jsonPointer": "/pageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [],
        "path": [
          "pageId"
        ],
        "isRelationalSplit": false
      }
    ],
    "MediaRichText": [
      {
        "jsonPointer": "/linkList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "linkList"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/componentDataList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "componentDataList"
        ],
        "isRelationalSplit": false
      }
    ],
    "Page": [
      {
        "jsonPointer": "/parentPageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "parentPageId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/desktop/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "desktop",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/mobile/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "mobile",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/ogImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "ogImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "RichTextImage": [
      {
        "jsonPointer": "/text",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "text"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/image",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "image"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextInput": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextInputA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "CheckboxInput": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "QuickActionBarItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "BasicMenuItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BasicMenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/iconRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "VectorImage"
        ],
        "path": [
          "iconRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "CustomMenu": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "BasicMenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "CustomMenusCollection": [
      {
        "jsonPointer": "/menus",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu",
          "Builder.MenuItems"
        ],
        "path": [
          "menus"
        ],
        "isRelationalSplit": false
      }
    ],
    "CustomMenuDataRef": [
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRefA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "Menu": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ImageButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/defaultImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "defaultImage"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/hoverImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "hoverImage"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/activeImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "activeImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "SubscribeForm": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContactForm": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "DynamicContactForm": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "FlashComponent": [
      {
        "jsonPointer": "/placeHolderImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "placeHolderImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "GeoMapLocation": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "GeoMap": [
      {
        "jsonPointer": "/locations",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "GeoMapLocation"
        ],
        "path": [
          "locations"
        ],
        "isRelationalSplit": false
      }
    ],
    "LinkableFlashComponent": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/placeHolderImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "placeHolderImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "LinkableButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SiteButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "TinyMenu": [
      {
        "jsonPointer": "/loginSocialBarRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "LoginSocialBar"
        ],
        "path": [
          "loginSocialBarRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "LoginSocialBar": [
      {
        "jsonPointer": "/menuItemsRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRef"
        ],
        "path": [
          "menuItemsRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/iconItemsRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRef"
        ],
        "path": [
          "iconItemsRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "PagesGroupData": [
      {
        "jsonPointer": "/pages",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "pages"
        ],
        "isRelationalSplit": false
      }
    ],
    "PagesGroupCollection": [
      {
        "jsonPointer": "/groups",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PagesGroupData"
        ],
        "path": [
          "groups"
        ],
        "isRelationalSplit": false
      }
    ],
    "PermaLink": [
      {
        "jsonPointer": "/dataItemRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "dataItemRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/correctPermaLinkRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "correctPermaLinkRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "SelectableList": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SelectOption"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "RadioGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RadioButton"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "CheckboxGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CheckboxInput"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "StyledText": [
      {
        "jsonPointer": "/linkList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PageLink",
          "ExternalLink",
          "EmailLink",
          "AnchorLink",
          "DocumentLink",
          "PhoneLink",
          "DynamicPageLink",
          "TextLink",
          "LoginToWixLink",
          "WhatsAppLink",
          "AddressLink",
          "TpaPageLink"
        ],
        "path": [
          "linkList"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StyledTextA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StyledTextLinkHelper": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "SvgShape": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "VectorImage": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "Video": [
      {
        "jsonPointer": "/posterImage",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "posterImage"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPAWidget": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TPAData"
        ],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPA": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPASection": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TPAData"
        ],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "TPAMultiSection": [
      {
        "jsonPointer": "/tpaData",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TPAData"
        ],
        "path": [
          "tpaData"
        ],
        "isRelationalSplit": false
      }
    ],
    "RssButton": [
      {
        "jsonPointer": "/image",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "image"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "AppPage": [
      {
        "jsonPointer": "/parentPageId",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "Page",
          "AppPage"
        ],
        "path": [
          "parentPageId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/desktop/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "desktop",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/pageBackgrounds/mobile/ref",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "pageBackgrounds",
          "mobile",
          "ref"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/ogImageRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "ogImageRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "StripContainerSlideShowSlide": [
      {
        "jsonPointer": "/background",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "background"
        ],
        "isRelationalSplit": false
      }
    ],
    "Repeater": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "RepeaterA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageButtonWithText": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      }
    ],
    "InternalRef": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "ForwardRef": [
      {
        "jsonPointer": "/rootCompId",
        "isList": false,
        "referencedMap": "DESKTOP",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "rootCompId"
        ],
        "isRelationalSplit": false
      }
    ],
    "LightboxContainer": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "LightboxA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "ContainerData": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContainerA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "MediaBoxData": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ContainerA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "MultiStateBoxData": [
      {
        "jsonPointer": "/defaultStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "defaultStateId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/selectedStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "selectedStateId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MultiStateBoxDataA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StateBox": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StateBoxA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StateBoxState": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StateBoxStateA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.MenuItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Builder.MenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.MenuItems": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Builder.MenuItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.Video": [
      {
        "jsonPointer": "/poster",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Builder.Image"
        ],
        "path": [
          "poster"
        ],
        "isRelationalSplit": false
      }
    ],
    "Builder.RichText": [
      {
        "jsonPointer": "/linkList",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PageLink",
          "ExternalLink",
          "EmailLink",
          "AnchorLink",
          "DocumentLink",
          "PhoneLink",
          "DynamicPageLink",
          "TextLink",
          "LoginToWixLink",
          "WhatsAppLink",
          "AddressLink",
          "TpaPageLink"
        ],
        "path": [
          "linkList"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiButton": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiDatePicker": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/disabledDaysOfWeek",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "disabledDaysOfWeek"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/enabledDateRanges",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MobuiDateRangeType"
        ],
        "path": [
          "enabledDateRanges"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/disabledDateRanges",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MobuiDateRangeType"
        ],
        "path": [
          "disabledDateRanges"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/disabledDates",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "disabledDates"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiImage": [
      {
        "jsonPointer": "/src",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "src"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiPicker": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "MobuiPickerItemType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiVideoPlayer": [
      {
        "jsonPointer": "/poster",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "poster"
        ],
        "isRelationalSplit": false
      }
    ],
    "mobui.MobuiMultiStateBoxData": [
      {
        "jsonPointer": "/defaultStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "defaultStateId"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/selectedStateId",
        "isList": false,
        "referencedMap": "components",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": false,
        "refTypes": [
          "Component",
          "Container",
          "RefComponent",
          "RepeaterContainer"
        ],
        "path": [
          "selectedStateId"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.Logo": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.ProductSpecification": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.ShareButtons": [
      {
        "jsonPointer": "/buttons",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "IShareButton"
        ],
        "path": [
          "buttons"
        ],
        "isRelationalSplit": false
      }
    ],
    "IShareButton": [
      {
        "jsonPointer": "/illustration",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "illustration"
        ],
        "isRelationalSplit": false
      }
    ],
    "BreadcrumbsData": [
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRefA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "CollapsibleTextData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "ComboBoxInputData": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SelectOption"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.FastGallery": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "Image"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/wixSDKItems",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "wixSDKItems"
        ],
        "isRelationalSplit": false
      }
    ],
    "ImageX": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "MenuData": [
      {
        "jsonPointer": "/menuRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": false,
        "isRefOwner": false,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenu"
        ],
        "path": [
          "menuRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "CustomMenuDataRefA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.MenuList": [
      {
        "jsonPointer": "/menus",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "menus"
        ],
        "isRelationalSplit": false
      }
    ],
    "MusicPlayerData": [
      {
        "jsonPointer": "/audioRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "audioRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/coverRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "coverRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "Pagination": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "PaginationA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "Section": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SectionA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "SelectionTagsList": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "SelectionTag": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "SiteButtonData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SiteButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "StylableButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "StylableButtonA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "SvgImage": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "wixui.Tabs": [
      {
        "jsonPointer": "/a11y",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TabsA11y"
        ],
        "path": [
          "a11y"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextEffectsSharedData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextMarqueeData": [
      {
        "jsonPointer": "/items",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "TextMarqueeItem"
        ],
        "path": [
          "items"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextMarqueeItem": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextFxData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextOnPathData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "TextParticlesData": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "VideoPlayer": [
      {
        "jsonPointer": "/videoRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "videoRef"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/logoRef",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [],
        "path": [
          "logoRef"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.ControlTypes": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/thumbnails",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "thumbnails"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardIconButton": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardInfoIcon": [
      {
        "jsonPointer": "/tooltipLink",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "tooltipLink"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardInput": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardNumberInput": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.DashboardTextButton": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuButton": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuCheckboxGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuColumnControllerControl": [
      {
        "jsonPointer": "/columns",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "columns"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuDropdown": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuEmptyState": [
      {
        "jsonPointer": "/illustration",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "illustration"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuHorizontalTabs": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuLeftTextButton": [
      {
        "jsonPointer": "/prefixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "prefixIcon"
        ],
        "isRelationalSplit": false
      },
      {
        "jsonPointer": "/suffixIcon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "suffixIcon"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuRadioButtonGroup": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuRichText": [
      {
        "jsonPointer": "/link",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ExternalLink",
          "EmailLink",
          "PhoneLink",
          "WhatsAppLink",
          "PageLink",
          "AddressLink",
          "AnchorLink",
          "DynamicPageLink",
          "TpaPageLink",
          "DocumentLink",
          "FormSubmitButtonLink",
          "LoginToWixLink"
        ],
        "path": [
          "link"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WbuThumbnails": [
      {
        "jsonPointer": "/options",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "ThumbnailItemData"
        ],
        "path": [
          "options"
        ],
        "isRelationalSplit": false
      }
    ],
    "ThumbnailItemData": [
      {
        "jsonPointer": "/illustration",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "illustration"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WutAvatarGroup": [
      {
        "jsonPointer": "/avatars",
        "isList": true,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "defaultItemSchemaType"
        ],
        "path": [
          "avatars"
        ],
        "isRelationalSplit": false
      }
    ],
    "dsgnsys.WutBadge": [
      {
        "jsonPointer": "/icon",
        "isList": false,
        "referencedMap": "document_data",
        "shouldCollect": true,
        "isRefOwner": true,
        "shouldValidate": true,
        "refTypes": [
          "SVGItem"
        ],
        "path": [
          "icon"
        ],
        "isRelationalSplit": false
      }
    ]
  }
}
